export default __webpack_public_path__ + "static/media/kitchen1-2048w.3a0fc955.png";